/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ documentName: NonNullable<unknown> }} Coinvestments_Ndadocument_Viewarialabel4Inputs */

const en_coinvestments_ndadocument_viewarialabel4 = /** @type {(inputs: Coinvestments_Ndadocument_Viewarialabel4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`View NDA document: ${i?.documentName}`)
};

/**
* | output |
* | --- |
* | "View NDA document: {documentName}" |
*
* @param {Coinvestments_Ndadocument_Viewarialabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndadocument_viewarialabel4 = /** @type {((inputs: Coinvestments_Ndadocument_Viewarialabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndadocument_Viewarialabel4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndadocument_viewarialabel4(inputs)
});
export { coinvestments_ndadocument_viewarialabel4 as "coInvestments_ndaDocument_viewAriaLabel" }